﻿<mat-toolbar fxLayout="row" fxLayoutAlign="center center">
    <strong>Add Item Adjustment</strong>
</mat-toolbar>

<form [formGroup]="addAdjustmentForm">
    <div *ngIf="isLoaded" fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-between start">
            <lgd-text controlName="number" label="Number" telemetry="Edit-Number-ItemAdjustment-Inventory">
            </lgd-text>

            <lgd-date-picker fxFlex="60" controlName="adjustmentDate" label="Date" telemetry="Edit-AdjustmentDate-ItemAdjustment-Inventory">
            </lgd-date-picker>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between start">
            <lgd-text fxFlex="100" controlName="description" label="Description" telemetry="Edit-Description-ItemAdjustment-Inventory">
            </lgd-text>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between start">
            <lgd-typeahead *ngIf="!filterItems" fxFlex="100" controlName="item" label="Item" (searchTextChanged)="lookupItems($event)" [options]="itemsObservable" telemetry="Edit-Item-ItemAdjustment-Inventory">
            </lgd-typeahead>

            <lgd-select *ngIf="filterItems" fxFlex="100" controlName="item" label="Item" [options]="itemsObservable" aria-label="Selection-Item-ItemAdjustment-Inventory">
            </lgd-select>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between start">
            <lgd-typeahead controlName="location" label="Location" (searchTextChanged)="lookupLocations($event)" [options]="locationsObservable" telemetry="Edit-Location-ItemAdjustment-Inventory">
            </lgd-typeahead>

            <lgd-select fxFlex="45" controlName="transactionCode" label="Transaction Code" [options]="transactionCodesObservable" aria-label="Selection-TransactionCode-ItemAdjustment-Inventory">
            </lgd-select>
        </div>

        <div fxLayout="row">
            <div class="no-wrap" fxFlex="20">
                Available: {{available}}
            </div>
            <span fxFlex></span>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between start">
            <lgd-number controlName="quantity" label="Quantity" telemetry="Edit-Quantity-ItemAdjustment-Inventory">
            </lgd-number>

            <lgd-currency fxFlex="45" controlName="price" label="Price" telemetry="Edit-Price-ItemAdjustment-Inventory">
            </lgd-currency>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between start">
            <lgd-typeahead fxFlex="100" controlName="projectAccount" label="Project Account" (searchTextChanged)="lookupProjectAccounts($event)" [options]="projectAccountsObservable" telemetry="Edit-ProjectAccount-ItemAdjustment-Inventory">
            </lgd-typeahead>

        </div>

        <div *ngIf="saveErrorMessage">{{saveErrorMessage}}</div>
    </div>
</form>

<div fxLayout="row" fxLayoutAlign="end center">
    <command-bar [commands]="commands" telemetry="CmdBar-CommandKey-ItemAdjustment-Inventory"></command-bar>
</div>

<mat-progress-bar *ngIf="processing" mode="indeterminate">
</mat-progress-bar>
